<div class="login-container">
  <!-- Left Panel -->
  <div class="left-panel">
    <div class="top-logos">
      <img src="assets/dashboard icons/logo1.png">
      <img src="assets/dashboard icons/logo2.png">
      <img class="asha-saathi-logo" src="assets/dashboard icons/ashasathilogo.png">
      <img src="assets/dashboard icons/logo4.png">
      <img src="assets/dashboard icons/logo5.png">
    </div>
    <!-- <div class="left-panel-text">
      Accredited Social Health Activists
    </div> -->
    <div class="left-panel-text">
      {{ langService.currentLang === 'mr'
      ? 'मान्यताप्राप्त सामाजिक आरोग्य कार्यकर्त्या'
      : 'Accredited Social Health Activists' }}
    </div>
    <img src="assets/dashboard icons/AshaPic.png" alt="Asha" />
  </div>

  <div class="right-container">
    <div class="login-card">
      <!-- Desktop logo -->
      <!-- <img src="assets/logo.png" width="60px" height="40px" alt="Asha" /> -->
      <img src="assets/icons/headericon_pink.png" alt="Asha" />
      <!-- <h2 class="login-title">Create New Password</h2> -->
      <h2 class="login-title">
        {{ langService.currentLang === 'mr'
        ? 'नवीन पासवर्ड तयार करा'
        : 'Create New Password' }}
      </h2>
      <!-- Mobile replacement image -->
      <img src="assets/loginImg.png" alt="Asha" class="mobile-login-image" />
      <p class="login-subtitle">
        {{ langService.currentLang === 'mr'
        ? 'तुमच्या खात्यासाठी नवीन पासवर्ड तयार करा'
        : 'Create New Password for your account' }}
      </p>
      <form class="login-form" (submit)="onSubmit()">

        <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top" class="custom-login-form"
          [showColonAfterLabel]="false">

          <dxi-form-item dataField="OldPassword" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
               placeholder: langService.currentLang === 'mr'
    ? 'जुना पासवर्ड टाका'
    : 'Enter Old Password',
              mode: oldpasswordMode,
              buttons: [{
                name: 'togglePassword',
                id:'OldPassword',
                value: formData.OldPassword,
                location: 'after',
                options: {
                  icon: oldpasswordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                  onClick: toggleOldPasswordVisibility
                }
              }]
            }">
            <!-- <dxo-label text="old password"></dxo-label> -->
               <dxo-label [text]="langService.currentLang === 'mr' ? 'जुना पासवर्ड' : 'Old Password'"></dxo-label>
            <!-- <dxi-form-validation-rule type="required" message="Password is required"></dxi-form-validation-rule> -->
          </dxi-form-item>

          <dxi-form-item dataField="NewPassword" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
              placeholder: langService.currentLang === 'mr'
    ? 'नवीन पासवर्ड टाका'
    : 'Enter New Password',
              mode: newpasswordMode,
              buttons: [{
                name: 'togglePassword',
                id:'NewPassword',
                value: formData.NewPassword,
                location: 'after',
                options: {
                  icon: newpasswordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                  onClick: toggleNewPasswordVisibility
                }
              }]
            }">
            <!-- <dxo-label text="new password"></dxo-label> -->
               <dxo-label [text]="langService.currentLang === 'mr' ? 'नवीन पासवर्ड' : 'New Password'"></dxo-label>
            <!-- <dxi-form-validation-rule type="required" message="Password is required"></dxi-form-validation-rule> -->
          </dxi-form-item>

          <dxi-form-item dataField="ConfirmPassword" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
              placeholder: langService.currentLang === 'mr'
    ? 'नवीन पासवर्डची पुष्टी करा'
    : 'Enter Confirm Password',
              mode: confirmpasswordMode,
              buttons: [{
                name: 'togglePassword',
                id:'ConfirmPassword',
                value: formData.ConfirmPassword,
                location: 'after',
                options: {
                  icon: confirmpasswordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                  onClick: toggleComfirmPasswordVisibility
                }
              }]
            }">
            <!-- <dxo-label text="confirm new password"></dxo-label> -->
               <dxo-label [text]="langService.currentLang === 'mr' ? 'पासवर्डची पुष्टी' : 'Confirm Password'"></dxo-label>

            <!-- <dxi-form-validation-rule type="required" message="Password is required"></dxi-form-validation-rule> -->
          </dxi-form-item>
        </dx-form>

        <dx-button [text]="langService.currentLang === 'mr' ? 'जतन करा' : 'Save'" type="default" stylingMode="contained" class="login-button"
          (click)="onSubmit()"></dx-button>
      </form>
    </div>
  </div>
</div>